import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
// import Login from '@/views/Login.vue'
// import Rigist from '@/views/Regist.vue'
// import NewsCenter from '@/views/NewsCenter.vue'
// import IndustryService from '@/views/IndustryService.vue'
// import MemberServices from '@/views/MemberServices.vue'
// import MeetingActivities from '@/views/MeetingActivities.vue'
// import PartyConstruction from '@/views/PartyConstruction.vue'
// import NewsDetail from '@/views/NewsDetail.vue'
// import PartySecondPage from '@/views/partySecondPage/partySecondPage.vue'
// import PartyLeads from '@/views/partySecondPage/components/page1.vue'
// import PartyDynamic from '@/views/partySecondPage/components/page2.vue'
// import StudySection from '@/views/partySecondPage/components/page3.vue'
// import PartyMember from '@/views/partySecondPage/components/page4.vue'
// import NewsSecondPage from '@/views/newsSecondPage/newsSecondPage.vue'
// import Notice from '@/views/newsSecondPage/components/page1.vue'
// import Politics from '@/views/newsSecondPage/components/page2.vue'
// import IndustryDynamics from '@/views/newsSecondPage/components/page3.vue'
// import Trends from '@/views/newsSecondPage/components/page4.vue'
// import BranchPage from '@/views/BranchPage/BranchPage.vue'
// import IndustrySecondPage from '@/views/industrySecondPage/industrySecondPage.vue'
// import MarkBuild from '@/views/industrySecondPage/components/page1.vue'
// import StandardDynamic from '@/views/industrySecondPage/components/page2.vue'
// import Investigate from '@/views/industrySecondPage/components/page3.vue'
// import ExpertsThink from '@/views/industrySecondPage/components/page4.vue'
// import MemberSecondPage from '@/views/memberSecondPage/memberSecondPage.vue'
// import Member from '@/views/memberSecondPage/components/page1.vue'
// import MemberStyle from '@/views/memberSecondPage/components/page2.vue'
// import EnergizeMember from '@/views/memberSecondPage/components/page3.vue'
// import TrainingServices from '@/views/TrainingServices.vue'
// import AssociationProfile from '@/views/AssociationProfile/index.vue'
// import Introduction from '@/views/AssociationProfile/components/Page1.vue'
// import AssociationLeaders from '@/views/AssociationProfile/components/Page2.vue'
// import Organization from '@/views/AssociationProfile/components/Page3.vue'
// import AssociationCharter from '@/views/AssociationProfile/components/Page4.vue'
// import ServiceCatalog from '@/views/AssociationProfile/components/Page5.vue'
// import LeadingTalent from '@/views/LeadingTalent.vue'
// import AccountCenter from '@/views/AccountCenter/index.vue'
// // 账户中心
// import AccountcenterPage from '@/views/AccountCenter/components/accountcenterPage'
// import AccountInfoManagement from '@/views/AccountCenter/components/accountInfoManagement'
// import TrainingCourseManagement from '@/views/AccountCenter/components/TrainingCourseManagement/trainingCourseManagement'
// import MembershipDues from '@/views/AccountCenter/components/MembershipDues'
// import InformationReleaseManagement from '@/views/AccountCenter/components/InformationReleaseManagement/informationReleaseManagement.vue'
// import AddInfoNews from '@/views/AccountCenter/components/AddInfoNews'
// import PreviewNews from '@/views/AccountCenter/components/PreviewNews'
// import MemberShip from '@/views/MembershipPage/memberShip'
// import LeadApplyDetails from '@/views/AccountCenter/components/TrainingCourseManagement/LeadApplyDetails'
// import CourseApplyDetails from '@/views/AccountCenter/components/TrainingCourseManagement/CourseApplyDetails'
// // 机构测评
// import AssessmentInstitutions from '@/views/AssessmentInstitutions/index.vue'
// import EvaluateHomePage from '@/views/AssessmentInstitutions/components/evaluateHomePage.vue'
// // 会议活动
// import MeetSecondPage from '@/views/meetSecondPage/index.vue'
// import MeetActivePage from '@/views/meetSecondPage/components/page1.vue'
// import MeetingNotice from '@/views/meetSecondPage/components/page2.vue'
// import BrandActivity from '@/views/meetSecondPage/components/page3.vue'
// // 会议详情
// import MeetDetail from '@/views/MeetDetail.vue'
// import CourseDetail from '@/views/CourseDetail.vue'
// // 培训服务
// import TarinSecondPage from '@/views/TarinSecondPage/index.vue'
// import TarinCourse from '@/views/TarinSecondPage/components/page1.vue'
// import TarinInform from '@/views/TarinSecondPage/components/page2.vue'
// import ChoicenessCourse from '@/views/TarinSecondPage/components/page3.vue'
// import TripartiteTarin from '@/views/TarinSecondPage/components/page4.vue'
// // 帮助中心
// import Help from '@/views/Help'
// // 找回密码
// import RetrievePassword from '@/views/RetrievePassword'
// // 搜索中心
// import SearchPage from '@/views/SearchPage'
// import RetrievePhone from '@/views/RetrievePhone'
// // 联合活动
// import JointActivity from '@/views/jointActivity'

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [{
    path: '/login',
    name: 'Login',
    // component: Login
    component: () => import('../views/Login.vue')
  },
  {
    path: '/regist',
    name: 'Rigist',
    // component: Rigist
    component: () => import('../views/Regist.vue')
  },
  {
    path: '/retrieve-password',
    name: 'RetrievePassword',
    // component: RetrievePassword
    component: () => import('../views/RetrievePassword.vue')
  },
  {
    path: '/retrieve-phone',
    name: 'RetrievePhone',
    // component: RetrievePhone
    component: () => import('../views/RetrievePhone.vue')
  },


  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/help',
    name: 'Help',
    // component: Help
    component: () => import('../views/Help.vue')

  },
  {
    path: '/search',
    name: 'SearchPage',
    // component: SearchPage
    component: () => import('../views/SearchPage.vue')
  },

  {
    path: '/news',
    name: 'NewsCenter',
    // component: NewsCenter
    component: () => import('../views/NewsCenter.vue')
  },
  {
    path: '/industry-service',
    name: 'IndustryService',
    // component: IndustryService
    component: () => import('../views/IndustryService.vue')
  },
  {
    path: '/member-service',
    name: 'MemberServices',
    // component: MemberServices
    component: () => import('../views/MemberServices.vue')
  },
  // 闪
  {
    path: '/meet-activity',
    name: 'MeetingActivities',
    // component: MeetingActivities
    component: () => import('../views/MeetingActivities.vue')
  },
  {
    path: '/party-cloum',
    name: 'PartyConstruction',
    // component: PartyConstruction
    component: () => import('../views/PartyConstruction.vue')
  },
  {
    path: '/news-detail',
    name: 'NewsDetail',
    // component: NewsDetail
    component: () => import('../views/NewsDetail.vue')
  },
  {
    path: '/meet-detail',
    name: 'MeetDetail',
    // component: MeetDetail
    component: () => import('../views/MeetDetail.vue')
  },
  {
    path: '/course-detail',
    name: 'CourseDetail',
    // component: CourseDetail
    component: () => import('../views/CourseDetail.vue')
  },
  {
    path: '/branch',
    name: 'BranchPage',
    // component: BranchPage
    component: () => import('../views/BranchPage/BranchPage.vue')
  },
  {
    path: '/experts-think',
    name: 'ExpertsThink',
    // component: ExpertsThink, 
    component: () => import('../views/industrySecondPage/components/page4.vue'),
    meta: {
      title: '专家库'
    }
  },
  {
    path: '/train-service',
    name: 'TrainingServices',
    // component: TrainingServices,
    component: () => import('../views/TrainingServices.vue')
    //     children: [
    //    { path: '/train-service', redirect: '/train-service/leade-talent' },
    //    { path: 'leade-talent', name: 'LeadingTalent', component: LeadingTalent, meta: { title: '领军人才' } },
    //  ]
  },
  // 领军人才
  {
    path: '/leade-talent',
    name: 'LeadingTalent',
    // component: LeadingTalent,
    component: () => import('../views/LeadingTalent.vue')
  },
  // 头雁
   {
    path: '/lead-goose',
    name: 'LeadGoose',
    // component: LeadingTalent,
    component: () => import('../views/leadgooseComponents/LeadGoose.vue')
  },
  // 联合活动
  {
    path: '/joint-activity',
    name: 'JointActivity',
    // component: JointActivity,
    component: () => import('../views/jointActivity.vue')
  },

  {
    path: '/association-profile',
    name: 'AssociationProfile',
    // component: AssociationProfile,
    component: () => import('../views/AssociationProfile/index.vue'),
    children: [{
        path: '/association-profile',
        redirect: '/association-profile/introduct'
      },
      {
        path: 'introduct',
        name: 'Introduction',
        // component: Introduction,
        component: () => import('../views/AssociationProfile/components/Page1.vue'),
        meta: {
          title: '协会简介'
        }
      },
      {
        path: 'association-leader',
        name: 'AssociationLeaders',
        // component: AssociationLeaders,
        component: () => import('../views/AssociationProfile/components/Page2.vue'),
        meta: {
          title: '协会领导'
        }
      },
      {
        path: 'organization',
        name: 'Organization',
        // component: Organization,
        component: () => import('../views/AssociationProfile/components/Page3.vue'),
        meta: {
          title: '组织机构'
        }
      },
      {
        path: 'association-charter',
        name: 'AssociationCharter',
        // component: AssociationCharter,
        component: () => import('../views/AssociationProfile/components/Page4.vue'),
        meta: {
          title: '协会章程'
        }
      },
      {
        path: 'service-catalog',
        name: 'ServiceCatalog',
        // component: ServiceCatalog,
        component: () => import('../views/AssociationProfile/components/Page5.vue'),
        meta: {
          title: '服务目录'
        }
      },
    ]

  },
  // 机构测评
  {
    path: '/assessment-institutions',
    name: 'AssessmentInstitutions',
    // component: AssessmentInstitutions,
    component: () => import('../views/AssessmentInstitutions/index.vue')
  },
  // 测评首页
  {
    path: '/evaluate-home',
    name: 'EvaluateHomePage',
    // component: EvaluateHomePage,
    component: () => import('../views/AssessmentInstitutions/components/evaluateHomePage.vue')
  },

  // 賬戶中心
  {
    path: '/account-center',
    name: 'AccountCenter',
    // component: AccountCenter,
    component: () => import('../views/AccountCenter/index.vue'),
    children: [{
        path: '/account-center',
        redirect: '/account-center/centerpage'
      },
      {
        path: 'centerpage',
        name: 'AccountcenterPage',
        // component: AccountcenterPage,
        component: () => import('../views/AccountCenter/components/accountcenterPage.vue'),
        meta: {
          title: '账户中心'
        }
      },
      {
        path: 'account-info',
        name: 'AccountInfoManagement',
        // component: AccountInfoManagement,
        component: () => import('../views/AccountCenter/components/accountInfoManagement.vue'),
        meta: {
          title: '账户信息管理'
        }
      },
      {
        path: 'train-course',
        name: 'TrainingCourseManagement',
        // component: TrainingCourseManagement,
        component: () => import('../views/AccountCenter/components/TrainingCourseManagement/trainingCourseManagement.vue'),
        meta: {
          title: '培训课程管理'
        }
      },
      {
        path: 'membership-duse',
        name: 'MembershipDues',
        // component: MembershipDues,
        component: () => import('../views/AccountCenter/components/MembershipDues.vue'),
        meta: {
          title: '会费缴纳'
        }
      },
      {
        path: 'info-release',
        name: 'InformationReleaseManagement',
        // component: InformationReleaseManagement,
        component: () => import('../views/AccountCenter/components/InformationReleaseManagement/informationReleaseManagement.vue'),
        meta: {
          title: '信息发布管理'
        }
      },
      {
        path: 'add-news',
        name: 'AddInfoNews',
        // component: AddInfoNews,
        component: () => import('../views/AccountCenter/components/AddInfoNews.vue'),
        meta: {
          title: '新增信息发布'
        }
      },
      {
        path: 'perview-news',
        name: 'PreviewNews',
        // component: PreviewNews,
        component: () => import('../views/AccountCenter/components/PreviewNews.vue'),
        meta: {
          title: '预览信息'
        }
      },
      {
        path: 'member-ship',
        name: 'MemberShip',
        // component: MemberShip,
        component: () => import('../views/MembershipPage/memberShip.vue'),
        meta: {
          title: '申请入会'
        }
      },
      {
        path: 'lead-applydetail',
        name: 'LeadApplyDetails',
        // component: LeadApplyDetails,
        component: () => import('../views/AccountCenter/components/TrainingCourseManagement/LeadApplyDetails.vue'),
        meta: {
          title: '领军人才报名详情'
        }
      },
      {
        path: 'lead-gooseapplydetail',
        name: 'LeadGooseApplyDetails',
        // component: LeadApplyDetails,
        component: () => import('../views/AccountCenter/components/TrainingCourseManagement/LeadGooseApplyDetails.vue'),
        meta: {
          title: '头雁人才报名详情'
        }
      },
      {
        path: 'course-applydetail',
        name: 'CourseApplyDetails',
        // component: CourseApplyDetails,
        component: () => import('../views/AccountCenter/components/TrainingCourseManagement/CourseApplyDetails.vue'),
        meta: {
          title: '课程报名详情'
        }
      },
      // 专家库相关
      {
        path: 'add-specialist',
        name: 'AddSpecialist',
        // component: AddInfoNews,
        component: () => import('../views/AccountCenter/components/ExpertDatabase/AddSpecialist.vue'),
        meta: {
          title: '新增专家库'
        }
      },
      {
        path: 'expert-database',
        name: 'ExpertDatabaseManagement',
        // component: InformationReleaseManagement,
        component: () => import('../views/AccountCenter/components/ExpertDatabase/index.vue'),
        meta: {
          title: '专家库申请发布'
        }
      },

    ]
  },
  {
    path: '/party-secondpage',
    name: 'PartySecondPage',
    // component: PartySecondPage,
    component: () => import('../views/partySecondPage/partySecondPage.vue'),
    children: [{
        path: '/party-secondpage',
        redirect: '/party-secondpage/party-leads'
      },
      {
        path: 'party-leads',
        name: 'PartyLeads',
        // component: PartyLeads,
        component: () => import('../views/partySecondPage/components/page1.vue'),
        meta: {
          title: '党建引领'
        }
      },
      {
        path: 'party-dynamic',
        name: 'PartyDynamic',
        // component: PartyDynamic,
        component: () => import('../views/partySecondPage/components/page2.vue'),
        meta: {
          title: '党建动态'
        }
      },
      {
        path: 'study-section',
        name: 'StudySection',
        // component: StudySection,
        component: () => import('../views/partySecondPage/components/page3.vue'),
        meta: {
          title: '学习园地'
        }
      },
      {
        path: 'party-member',
        name: 'PartyMember',
        // component: PartyMember,
        component: () => import('../views/partySecondPage/components/page4.vue'),
        meta: {
          title: '会员党建'
        }
      },
    ]
  },
  {
    path: '/news-secondpage',
    name: 'NewsSecondPage',
    // component: NewsSecondPage,
    component: () => import('../views/newsSecondPage/newsSecondPage.vue'),
    children: [{
        path: '/news-secondpage',
        redirect: '/news-secondpage/notice'
      },
      {
        path: 'notice',
        name: 'Notice',
        // component: Notice,
        component: () => import('../views/newsSecondPage/components/page1.vue'),
        meta: {
          title: '通知公告'
        }
      },
      {
        path: 'politics',
        name: 'Politics',
        // component: Politics,
        component: () => import('../views/newsSecondPage/components/page2.vue'),
        meta: {
          title: '时政要闻'
        }
      },
      {
        path: 'industry-dynamics',
        name: 'IndustryDynamics',
        // component: IndustryDynamics,
        component: () => import('../views/newsSecondPage/components/page3.vue'),
        meta: {
          title: '行业动态'
        }
      },
      // { path: 'trends', name: 'Trends', component: Trends, meta: { title: '协会动态' } },
    ]
  },
  {
    path: '/industry-secondpage',
    name: 'IndustrySecondPage',
    // component: IndustrySecondPage,
    component: () => import('../views/industrySecondPage/industrySecondPage.vue'),
    children: [{
        path: '/industry-secondpage',
        redirect: '/industry-secondpage/mark-build'
      },
      {
        path: 'mark-build',
        name: 'MarkBuild',
        // component: MarkBuild,
        component: () => import('../views/industrySecondPage/components/page1.vue'),
        meta: {
          title: '团标建设'
        }
      },
      {
        path: 'standard-dynamic',
        name: 'StandardDynamic',
        // component: StandardDynamic,
        component: () => import('../views/industrySecondPage/components/page2.vue'),
        meta: {
          title: '标准动态'
        }
      },
      {
        path: 'investigate',
        name: 'Investigate',
        // component: Investigate,
        component: () => import('../views/industrySecondPage/components/page3.vue'),
        meta: {
          title: '调查研究'
        }
      },
      // { path: 'experts-think', name: 'ExpertsThink', component: ExpertsThink, meta: { title: '专家库' } },
    ]
  },
  {
    path: '/member-secondpage',
    name: 'MemberSecondPage',
    // component: MemberSecondPage,
    component: () => import('../views/memberSecondPage/memberSecondPage.vue'),
    children: [{
        path: '/member-secondpage',
        redirect: '/member-secondpage/member'
      },
      {
        path: 'member',
        name: 'Member',
        // component: Member,
        component: () => import('../views/memberSecondPage/components/page1.vue'),
        meta: {
          title: '会员名录'
        }
      },
      {
        path: 'member-style',
        name: 'MemberStyle',
        // component: MemberStyle,
        component: () => import('../views/memberSecondPage/components/page2.vue'),
        meta: {
          title: '会员风采'
        }
      },
      {
        path: 'energize-member',
        name: 'EnergizeMember',
        // component: EnergizeMember,
        component: () => import('../views/memberSecondPage/components/page3.vue'),
        meta: {
          title: '赋能会员'
        }
      },
    ]
  },
  {
    path: '/meet-secondpage',
    name: 'MeetSecondPage',
    // component: MeetSecondPage,
    component: () => import('../views/meetSecondPage/index.vue'),
    children: [{
        path: '/meet-secondpage',
        redirect: '/meet-secondpage/meetactive'
      },
      {
        path: 'meetactive',
        name: 'MeetActivePage',
        // component: MeetActivePage,
        component: () => import('../views/meetSecondPage/components/page1.vue'),
        meta: {
          title: '会议活动'
        }
      },
      {
        path: 'meet-notice',
        name: 'MeetingNotice',
        // component: MeetingNotice,
        component: () => import('../views/meetSecondPage/components/page2.vue'),
        meta: {
          title: '会议通知'
        }
      },
      {
        path: 'brand-active',
        name: 'BrandActivity',
        // component: BrandActivity,
        component: () => import('../views/meetSecondPage/components/page3.vue'),
        meta: {
          title: '品牌活动'
        }
      },
    ]
  },
  {
    path: '/tarin-secondpage',
    name: 'TarinSecondPage',
    // component: TarinSecondPage,
    component: () => import('../views/TarinSecondPage/index.vue'),
    children: [{
        path: '/tarin-secondpage',
        redirect: '/tarin-secondpage/tarin-course'
      },
      {
        path: 'tarin-course',
        name: 'TarinCourse',
        // component: TarinCourse,
        component: () => import('../views/TarinSecondPage/components/page1.vue'),
        meta: {
          title: '培训报名'
        }
      },
      {
        path: 'tarin-inform',
        name: 'TarinInform',
        // component: TarinInform,
        component: () => import('../views/TarinSecondPage/components/page2.vue'),
        meta: {
          title: '培训通知'
        }
      },
      {
        path: 'choiceness-course',
        name: 'ChoicenessCourse',
        // component: ChoicenessCourse,
        component: () => import('../views/TarinSecondPage/components/page3.vue'),
        meta: {
          title: '精选课程'
        }
      },
      {
        path: 'tripartite-train',
        name: 'TripartiteTarin',
        // component: TripartiteTarin,
        component: () => import('../views/TarinSecondPage/components/page4.vue'),
        meta: {
          title: '课程培训'
        }
      },

    ]
  },
]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // console.log(to,from,sessionStorage.getItem('hashId'))
  // || sessionStorage.hashId == '#2'
  if (from.fullPath.includes('productService') || to.meta.done && from.meta.done) {
    next()
  } else {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
    next()
  }
})

export default router